import { ofType, combineEpics } from "redux-observable";
import * as Rx from "rxjs";
import * as RxOp from "rxjs/operators";

import { loginAlertBarAction, LOGOUT_FROM_INACTIVITY } from "./LoginPage.state";
import { replaceAlerts } from "@/components/alert-bar/AlertBar.state";

const logoutUserAfterInactivityEpic = (action$) =>
  action$.pipe(
    ofType(LOGOUT_FROM_INACTIVITY),
    RxOp.mergeMap(() =>
      Rx.of(
        loginAlertBarAction(
          replaceAlerts({
            heading: "Session Expired Due to Inactivity",
            text: "For security purposes, you have been logged out. Please log in again to continue.",
            variant: "warn",
          })
        )
      )
    )
  );

export default combineEpics(logoutUserAfterInactivityEpic);
